import { make } from 'vuex-pathify'
import * as uuid from 'uuid/v4'

export default ({ model = {}, state = {}, actions = {}, getters = {} }) => {
  const createModel = () => ({
    uuid: uuid(),
    ...model
  })

  const _state = {
    ...state,
    data: {},
    model: createModel()
  }

  const mutations = make.mutations(_state)

  const _actions = {
    mapData({ commit }, payload) {
      const data = payload.reduce((acc, item) => {
        acc[item.uuid] = item
        return acc
      }, {})
      commit('SET_DATA', data)
    },
    ...actions
  }

  return {
    namespaced: true,
    state: _state,
    actions: _actions,
    getters,
    mutations: {
      ...mutations,
      remove(state, uuid) {
        const data = Object.assign({}, state.data)
        delete data[uuid]
        state.data = data
      },
      create(state, payload) {
        state.data = Object.assign(
          {},
          { ...state.data, [payload.uuid]: payload }
        )
      },
      resetModel(state) {
        state.model = createModel()
      }
    }
  }
}
